module.exports = "<div class=\"rw-move-widget\">\r\n   <i class=\"fa fa-arrows fa-lg\"\r\n      aria-label=\"Move widget\"></i>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/rw-move-widget/rw-move-widget.html
// module id = 1757
// module chunks = 0